import React                   from 'react';
import { Button }              from 'antd';
import { DownloadOutlined }    from '@ant-design/icons';
import { downloadFileFromUrl } from 'utils/downloadFile';

interface AppDownloadBtnProps {
  filename: string;
  link: string;
  text: any;
}

class AppDownloadBtn extends React.Component<AppDownloadBtnProps> {
  public render() {
    const { text } = this.props;
    return (
      <Button
        className="AppDownloadBtn"
        icon={<DownloadOutlined />}
        onClick={this.handleClick}
        style={{
          alignItems: 'center',
          display: 'flex',
          height: 'auto',
          maxWidth: '100%',
          padding: 8,
        }}
        type="primary"
      >
        <span
          style={{
            display: 'block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'break-spaces',
          }}
        >
          {text}
        </span>
      </Button>
    );
  }

  private handleClick = () => {
    const { filename, link } = this.props;
    downloadFileFromUrl(link, filename);
  };
}

export default AppDownloadBtn;
